import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { ReelCategoriesService } from '../../../../services/reel-categories.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { CreateEditReelCategoryComponent } from './create-edit-reel-category/create-edit-reel-category.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-reel-categories',
  templateUrl: './reel-categories.component.html',
  styleUrls: ['./reel-categories.component.scss']
})
export class ReelCategoriesComponent implements OnInit,OnDestroy {
	dtConfig = {
		config: {
			base: this.reelCategoriesService,
			api: 'datatable',
			rowsPerPage: 10,
			order: [[2, 'desc']],
			params: {
				key: ''
			}
		},
		columns: [
			{
				title: 'ID',
				field: 'id'
			},
			{
				title: 'Titulo',
				field: 'title',
			},
			{
				title: 'Categoria',
				field: 'category_id',
			},
			{
				title: 'Tipo',
				field: 'type'
			}
		],
		actions: [
			{
				display: 'Editar',
				icon: 'fa-pencil',
				event: 'reel-categories.edit',
				conditionality: 'true'
			},
			{
				display: 'Eliminar',
				icon: 'fa-trash',
				event: 'reel-categories.delete',
				conditionality: 'true'
			}
		]
	};

	private atComponentDestroy = new Subject();

	constructor(
		private reelCategoriesService: ReelCategoriesService,
		private swal: SwalService,
		private broadcast: BroadcastService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private nrModal: NRModalService
	) { }

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	ngOnInit(): void {
		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				const props = this.prepareProps(event);
				if (props) {
					this.nrModal.open(props, 'xl');
				}
			});
	}

	/**
	 * Prepare the Reel Category data for the modal window
	 * @param event
	 * @returns
	 */
	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel;
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {}
		};

		switch (event.name) {
			case 'reel-categories.add':
				props.modalModel.component = CreateEditReelCategoryComponent;
				props.modalModel.modalConfiguration = {
					title: 'Agregar Categoría de Reel'
				};
				break;

			case 'reel-categories.edit':
				props.modalModel.component = CreateEditReelCategoryComponent;
				props.modalModel.modalConfiguration = {
					title: 'Editar Reel'
				};
				break;

			case 'reel-categories.config':
				props.modalModel.component = CreateEditReelCategoryComponent;
				props.modalModel.modalConfiguration = {
					title: 'Configurar Reel'
				};
				break;

			case 'reel-categories.delete':
				this.delete(event.data);
				return false;
				break;
		}

		return props;
	}

	/**
	 * Open ADD modal window
	 */
	add(): void {
		this.broadcast.fire({
			name: 'reel-categories.add',
			type: EventType.MODAL,
			data: {}
		});
	}

	/**
	 * Get User confirmation and send the signal to the server
	 * @param data
	 */
	delete(data): void {
		const swalParams = {
			title: '¿Estás seguro de querer eliminar el reel?'
		};

		this.swal.warning(swalParams).then(result => {
			if (result.value) {
				this.reelCategoriesService.delete(data.item.id).subscribe((resp: any) => {
					if (resp.success) {
						this.swal.success({ title: 'Reel eliminado exitosamente' }).then(() => {
							this.broadcast.reloadDataTable();
						});
					} else {
						this.swal.error('Ocurrio un error al intentar borrar el Reel');
					}
				});
			}
		});
	}
}
